module.exports = __webpack_public_path__ + "img/item-3.6970360a.png";